module.exports = __webpack_public_path__ + "static/media/HAUX_TRAINING_GUIAS_AEROBICO.32f895c9.pdf";